import { render, staticRenderFns } from "./ThemeProduct.vue?vue&type=template&id=634a12ac&scoped=true&"
import script from "./ThemeProduct.vue?vue&type=script&lang=js&"
export * from "./ThemeProduct.vue?vue&type=script&lang=js&"
import style0 from "./ThemeProduct.vue?vue&type=style&index=0&id=634a12ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a12ac",
  null
  
)

export default component.exports